export { default as labels } from './labels'
export { default as locales } from './locales'
export { default as localesAndLabels } from './localesAndLabels'
